import { useState } from "react";
import { bugsnag } from "@miplatform/utils";

export const useAddAssignmentTemplateModal = ({
  getAllAssignmentTemplates,
}) => {
  const [templates, setTemplates] = useState([]);

  const getAssignmentTemplates = async () => {
    try {
      const result = await getAllAssignmentTemplates();

      setTemplates(result);
    } catch (error) {
      bugsnag.notify(error);
    }
  };

  const findTemplate = (name) =>
    templates.find(({ name: templateName }) => templateName === name);

  return {
    templates: templates.map(({ name, id }) => ({
      key: id,
      label: name,
      value: name,
    })),
    findTemplate,
    getAssignmentTemplates,
  };
};
